export function setLayout(tipo) {
	return {
		type: '@auth/SET_LAYOUT',
		payload: { tipo },
	};
}
